import React, { Component } from 'react';
import { bool, func, object } from 'prop-types';
import { Box, Button } from '@mui/material';
import { connect } from 'formik';
import { I18n } from 'utils/i18n';

class ActionButtons extends Component {
  handleReset = e => {
    const { onReset, formik } = this.props;
    onReset();
    formik.handleReset(e);
  };

  render() {
    const { formik, disabled } = this.props;
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Button
          variant="outlined"
          onClick={this.handleReset}
          disabled={disabled || formik.isSubmitting}
          sx={{ color: 'primary.ultraDark' }}
          type="reset"
          color="secondary"
        >
          {I18n.t('TeamDrawer.Cancel')}
        </Button>
        <Button
          variant="contained"
          disabled={disabled || formik.isSubmitting}
          color="primary"
          type="submit"
        >
          {formik.isSubmitting ? I18n.t('RulesDrawer.Saving') : I18n.t('RulesDrawer.Save')}
        </Button>
      </Box>
    );
  }
}

ActionButtons.propTypes = {
  formik: object.isRequired,
  onReset: func.isRequired,
  isEdit: bool.isRequired,
  disabled: bool,
};

ActionButtons.defaultProps = {
  disabled: false,
};

export default connect(ActionButtons);
